<script lang="ts">
import FaqCard from '@/components/common/FaqCard.vue'
import { useFaqStore } from '@/stores/faq'
import { defineComponent } from 'vue'

export default defineComponent({
  components: { FaqCard },
  props: {
    showBreadcrumb: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const categories = useFaqStore().faqPageCategories

    return { categories }
  },
  data() {
    return {
      isLoading: true,
    }
  },
})
</script>

<template>
  <AppSection>
    <div
      class="flex flex-row items-center gap-2 carousel-header @sm/main:min-h-8"
    >
      <AppIcon size="sm" class="sm:h-8 sm:w-8" :icon="Icons.Question"></AppIcon>
      <h2
        class="flex-1 overflow-hidden text-ellipsis text-nowrap text-lg/7 font-bold sm:text-2xl/10 uppercase"
      >
        Frequently Asked Questions
      </h2>
    </div>
    <p>Looking for help? Find it here...</p>

    <div
      class="mt-4 grid grid-cols-1 gap-4 @sm/main:grid-cols-2 @lg/main:grid-cols-3"
    >
      <FaqCard
        v-for="(faqCategory, index) in categories"
        :key="index"
        :to="`/faq/${faqCategory.slug}`"
        :icon="faqCategory.icon"
        :title="faqCategory.title"
      />
    </div>
  </AppSection>
</template>
